module.exports = __webpack_public_path__ + "static/media/signing-in.128ef0cf.svg";